var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { router } from '../utils/router';
export const TAB_PARAM_KEY = 'tab';
export function accountTripsTabsRoute(tabStr) {
    return [`?${TAB_PARAM_KEY}=${tabStr}`, undefined, { shallow: false }];
}
export function accountTripsTabsRouting(tabStr) {
    return __awaiter(this, void 0, void 0, function* () {
        yield router.push(tabStr, accountTripsTabsRoute);
    });
}
